// Created classes for each font in main css (styles.css) with their respective font settings.
const fonts = {
  'Padauk': { 'font': 'Padauk' },
  'Awami Nastaliq': { 'font': 'AwamiNastaliq' },
  'Scheherazade': { 'font': 'Scheherazade' },
  'Charis SIL': { 'font': 'CharisSIL' },
  // To make more complex script fonts available to select, add them here.
  //    Remember to copy the font files into the css folder and then create a class in styles.css (for example see `.AwamiNastaliq-text`).  Make sure to add the appropriate font settings.
};

export default fonts;
